import './Value.css';
export var valueStyle = '_1euwfb00-3-12-1';